import { Box, Divider, Flex, IconFont, Menu, pointer, Text } from '@byecode/ui'
import { ListItem4ByecodeUi } from '@lighthouse/shared'
import React, { useMemo, useState } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import styled from 'styled-components'

import { InheritLabel } from '@/components/InheritLabel'

import type { InteractionSettingSwitch } from '../types'
import { InteractionItem } from './InteractionItem'

export type { InteractionStyleSettingSwitch } from './InteractionItem'
const SCxExtra = styled(Flex)`
    color: var(--color-gray-400);
`

const SCxClose = styled(Flex)`
    width: 28px;
    height: 28px;
    background-color: var(--color-gray-100);
    border-radius: 50%;
    ${pointer}
`

const SCxContent = styled.div`
    flex: 1;
    overflow-y: auto;
`

interface InteractionSettingProps extends Partial<InteractionSettingSwitch> {
    prefixName?: string
}

// const interactionTextArr = ['悬浮态', '选中态', '禁用态']

export const InteractionSetting: React.FC<InteractionSettingProps> = ({
    prefixName = 'breakPoint',
    hoverStyle,
    activeStyle,
    disabledStyle
}) => {
    const [opened, setOpened] = useState(false)
    const { control } = useFormContext()
    const hoverStyleOpen = useWatch({ name: `${prefixName}.hoverStyle.open`, control })
    const activeStyleOpen = useWatch({ name: `${prefixName}.activeStyle.open`, control })
    const disabledStyleOpen = useWatch({ name: `${prefixName}.disabledStyle.open`, control })
    const extraText = useMemo(() => {
        const interactionOpen = [hoverStyleOpen && '悬浮态', activeStyleOpen && '选中态', disabledStyleOpen && '禁用态'].filter(Boolean)
        if (interactionOpen.length === 0) {
            return '未启用'
        }
        return interactionOpen.join('、')
    }, [hoverStyleOpen, activeStyleOpen, disabledStyleOpen])
    return (
        <Box>
            <Menu position="left" opened={opened} onChange={setOpened}>
                <Menu.Target>
                    <ListItem4ByecodeUi enableHover justifyContent="space-between" alignItems="center">
                        <InheritLabel
                            label="状态样式"
                            disable
                            name={[`${prefixName}.hoverStyle`, `${prefixName}.activeStyle`, `${prefixName}.disabledStyle`]}
                        />
                        <SCxExtra gap={4}>
                            <Text>{extraText}</Text>
                            <IconFont type="ArrowRightSmall" size={16} />
                        </SCxExtra>
                    </ListItem4ByecodeUi>
                </Menu.Target>
                <Menu.Dropdown style={{ padding: 0, maxHeight: '90%', overflow: 'hidden' }}>
                    <Box px={8}>
                        <ListItem4ByecodeUi justifyContent="space-between" alignItems="center" style={{ height: 56 }}>
                            <Text weight={600} size={16}>
                                状态样式
                            </Text>
                            <SCxClose onClick={() => setOpened(false)} justifyContent="center" alignItems="center">
                                <IconFont type="Close" fill="var(--color-gray-400)" />
                            </SCxClose>
                        </ListItem4ByecodeUi>
                    </Box>
                    <SCxContent>
                        {hoverStyle && (
                            <>
                                <Divider />
                                <InteractionItem prefixName={prefixName} interactionType="hoverStyle" title="悬浮态" {...hoverStyle} />
                            </>
                        )}
                        {activeStyle && (
                            <>
                                <Divider />
                                <InteractionItem prefixName={prefixName} interactionType="activeStyle" title="选中态" {...activeStyle} />
                            </>
                        )}
                        {disabledStyle && (
                            <>
                                <Divider />
                                <InteractionItem
                                    prefixName={prefixName}
                                    interactionType="disabledStyle"
                                    title="禁用态"
                                    {...disabledStyle}
                                />
                            </>
                        )}
                    </SCxContent>
                </Menu.Dropdown>
            </Menu>
        </Box>
    )
}
